// Use /api prefix - setupProxy.js proxies /api/* to backend
export const SERVER_URL = "/api";